import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer";
import * as cuComponent from "../../redux/reducers/building_component/componentReducer";
import * as utils from "../../redux/reducers/utils";
import { const_var, params } from "../../redux/reducers/reducer";
import { updateWainscotPriceFlag } from "../building/building_color/wainscotColor.helper";

export const AddDoorComponentonWall = async(compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType, isLandTshapeDoor,is_default_door) =>{
    if( params.m_s_n == 33 && childkey == "overhead_door_door" && const_var.installationsurfaceChange == true){
        const_var.checkOverHeadDoor = "overhead_door_door"
        params.p_i_s = 1
        utils.installationSurface(params.p_i_s)
    }
    let prom = Promise.resolve(undefined);
    return new Promise((res, rej) => {
        const_var.removed_door = '';
        const_var.AddDoorComponentonWallRes = res;
        updateWainscotPriceFlag();
        if(rot!=undefined && pos!=undefined)
            
        {
          
            const newfuncforDoorWindows = (compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType) => {
                prom = prom.then(async(res, rej) => {
                                // commonFunctionForColor(componentsize, parentkey, childkey, nestedkey,false,parentOBJ);
                                const ans = await cuComponent.loadDoorComponentOnWall(compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,undefined,parentOBJ, buildingType,undefined,undefined,undefined,undefined, isLandTshapeDoor, params.trimkit);
                            });                        
                        } 

                        newfuncforDoorWindows(compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType);

        }else{
           
            const newfuncforDoorWindows = (compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType) => {
                prom = prom.then(async(res, rej) => {
                                // commonFunctionForColor(componentsize, parentkey, childkey, nestedkey);
                                //const ans = await cuComponent.loadDoorComponentOnWall(compType, compName, wall, componentsize, parentkey, childkey, nestedkey, rot, pos, is_edit);
                                const ans = await cuComponent.loadDoorComponentOnWall(compType, compName, wall, componentsize, parentkey, childkey, nestedkey,undefined,pos,undefined,undefined,undefined,undefined,undefined,undefined,undefined, isLandTshapeDoor, params.trimkit,is_default_door);
                            });                        
                        } 

                        newfuncforDoorWindows(compType, compName, wall, componentsize, parentkey, childkey, nestedkey,rot,pos,is_edit,parentOBJ, buildingType);

       }
        
    })
    //cuBuilding.calculateDoorComponentPrice(true);
}

export const commonFunctionForComponent = ()=>{
    // console log removed for brevity
        let chkDoorIsExist = '';
        let newEntryData = JSON.parse(JSON.stringify(const_var.entry_points));
        if(newEntryData.length>0 && const_var.crmSetting.is_Edit==true)
        {
            newEntryData.map((data,i)=>{
                if(const_var.newComponentArray[data.parent_array_key]!=undefined)
                {
                    if(const_var.newComponentArray[data.parent_array_key][data.child_array_key]!=undefined && const_var.newComponentArray[data.parent_array_key][data.child_array_key][data.nested_array_key]!=undefined)
                    {
                        chkDoorIsExist = const_var.newComponentArray[data.parent_array_key][data.child_array_key][data.nested_array_key]['Size'][data.name];
                        if(data.entry_doorNewType != "Custom Size" && (const_var.newComponentArray[data.parent_array_key][data.child_array_key][data.nested_array_key]==undefined || const_var.newComponentArray[data.parent_array_key][data.child_array_key][data.nested_array_key]['Size'][data.name]==undefined))
                        {
                            cuComponent.RemoveDoorComponent(data.uniqueId, data.component_name)
                        }
                    }else{
                        cuComponent.RemoveDoorComponent(data.uniqueId, data.component_name)
                    }
                }else{
                    cuComponent.RemoveDoorComponent(data.uniqueId, data.component_name)
                }      
            })

        }
}

export const commonFunctionForColor = (componentsize, parentkey, childkey, nestedkey,chkColor,currentComponentData) =>{
    // console log removed for brevity
    let objData = (const_var.newComponentArray[parentkey][childkey][nestedkey]!=undefined)?const_var.newComponentArray[parentkey][childkey][nestedkey]['Size'][componentsize]:undefined;
    if(objData!=undefined && objData.color_cost_combination!=undefined && typeof objData.color_cost_combination=="string")
    {
        let newParseData = JSON.parse(objData.color_cost_combination);
        objData.color_cost_combination = (newParseData.color_cost_data!=undefined)?newParseData.color_cost_data:newParseData;
    }
    if(objData!=undefined && parentkey=="Garage" && objData.color_cost_combination!=undefined && objData.color_cost_combination!=null && objData.color_cost_combination.length>0)
    {
        const_var.garageDoorColor = [];
        if(currentComponentData!=undefined)
        {
            if(currentComponentData.entry_garageDoor_color_Obj!=undefined)
            {
                params.g_d_c_id = currentComponentData.entry_garageDoor_color_Obj.id;
                params.g_d_c_name = currentComponentData.entry_garageDoor_color_Obj.name;
                params.g_d_c = currentComponentData.entry_garageDoor_color_Obj.hex_value.replace('#', '0x');
            }
        }
        params.g_d_c_id = (chkColor==undefined)?'':params.g_d_c_id;
        objData.color_cost_combination.map((data,index)=>{
            data.color.map((value,key)=>{
                let findData = const_var.SendAPIBuildingData.garageDoorColor.find(findData=>findData?.hex_value?.toLowerCase()==value?.toLowerCase());
                if(findData!=undefined)
                {
                    if(params.g_d_c_id=='')
                    {
                        params.g_d_c_name = findData.name;
                        params.g_d_c_id = findData.id;
                        params.g_d_c = findData.hex_value.replace('#', '0x');
                    }
                    findData.cost = data.cost;
                    findData.percentage_of_cost = data.cost_type=="$"?0:1;
                    findData.is_show = true;
                    const_var.garageDoorColor[findData.id] = findData;
                }
            })
            
        })
        if(const_var.garageDoorColor.length==0)
        {
            params.g_d_c_id = '';
            for (var i = 0; i <= const_var.SendAPIBuildingData.garageDoorColor.length - 1; i++) {
                params.g_d_c_name = const_var.SendAPIBuildingData.garageDoorColor[0].name;
                params.g_d_c_id = const_var.SendAPIBuildingData.garageDoorColor[0].id;
                params.g_d_c = const_var.SendAPIBuildingData.garageDoorColor[0].hex_value.replace('#', '0x');

                const_var.garageDoorColor[const_var.SendAPIBuildingData.garageDoorColor[i].id] = const_var.SendAPIBuildingData.garageDoorColor[i];
            }
        }
        if (chkColor==undefined && (params.g_d_c != '0xffffff' || params.g_d_c != "#FFFFFF" || params.g_d_c != "#e8ebeb")) {
            let findwhiteColor =  const_var.garageDoorColor.find(color => color?.hex_value == "#ffffff" || color?.hex_value == "#FFFFFF" || color?.hex_value == "#e8ebeb" );
            if (findwhiteColor) {
                params.g_d_c_name = findwhiteColor.name;
                params.g_d_c_id = findwhiteColor.id;
                params.g_d_c = findwhiteColor.hex_value.replace('#', '0x');
            }
        }else{
            let findwhiteColor =  const_var.garageDoorColor.find(color => color?.id == params.g_d_c_id );
            if(findwhiteColor==undefined)
            {
                let findwhiteColorNew =  const_var.garageDoorColor.find(color => color?.hex_value == "#ffffff" || color?.hex_value == "#FFFFFF" || color?.hex_value == "#e8ebeb" );
                if (findwhiteColorNew) {
                    params.g_d_c_name = findwhiteColorNew.name;
                    params.g_d_c_id = findwhiteColorNew.id;
                    params.g_d_c = findwhiteColorNew.hex_value.replace('#', '0x');
                }
            }
        }
    }else{
        let colorObj = const_var.newComponentArray[parentkey][childkey][nestedkey]
        if(colorObj != undefined && colorObj.garageDoorColor != undefined && colorObj.garageDoorColor.length > 0) {
            let existedColorObj =  colorObj.garageDoorColor.find(color => color?.hex_value == params.g_d_c.replace('0x','#'));

            if(objData){
                if(existedColorObj) {
                    params.g_d_c_name = existedColorObj.name;
                    params.g_d_c_id = existedColorObj.id;
                    params.g_d_c = existedColorObj.hex_value.replace('#', '0x'); 
                    const_var.garageDoorColor = []
                    const_var.garageDoorColor[existedColorObj.id] = existedColorObj;
                } else {
                    params.g_d_c_id = '';
                    for (var i = 0; i <= const_var.SendAPIBuildingData.garageDoorColor.length - 1; i++) {
                       params.g_d_c_name = const_var.SendAPIBuildingData.garageDoorColor[0].name;
                       params.g_d_c_id = const_var.SendAPIBuildingData.garageDoorColor[0].id;
                       params.g_d_c = const_var.SendAPIBuildingData.garageDoorColor[0].hex_value.replace('#', '0x');
            
                       const_var.garageDoorColor[const_var.SendAPIBuildingData.garageDoorColor[i].id] = const_var.SendAPIBuildingData.garageDoorColor[i];
                   }
                }
            }

        } else {
            params.g_d_c_id = '';
            for (var i = 0; i <= const_var.SendAPIBuildingData.garageDoorColor.length - 1; i++) {
               params.g_d_c_name = const_var.SendAPIBuildingData.garageDoorColor[0].name;
               params.g_d_c_id = const_var.SendAPIBuildingData.garageDoorColor[0].id;
               params.g_d_c = const_var.SendAPIBuildingData.garageDoorColor[0].hex_value.replace('#', '0x');
    
               const_var.garageDoorColor[const_var.SendAPIBuildingData.garageDoorColor[i].id] = const_var.SendAPIBuildingData.garageDoorColor[i];
           }
        }

    }
}

export const updateBreezewayFrameAndStorages =(action, currentLength, height, length,popularSize,dimensionType) => {
    let breezewayFrameouts,leftFrameout,rightFrameout,size = '10x10',prevFrameLength,prevFrontStorageLength,prevBackStorageLength, posOffset = -0.09 ;
    const distanceOncenter = const_var.DistanceArr[params.p_b_t][params.p_r_s];
    const maxBreezewayLength = 20;
    breezewayFrameouts = const_var.entry_points.filter(door => (door.is_breezeway_frameout!==undefined && door.is_breezeway_frameout === true)); 
    leftFrameout = breezewayFrameouts.length > 0 && breezewayFrameouts.find(door => door.component_wall_name == "c_b_l_w" );
    rightFrameout = breezewayFrameouts.length > 0 && breezewayFrameouts.find(door => door.component_wall_name == "c_b_r_w" );
    prevFrameLength =  Number(leftFrameout.entry_dimension_width);
    prevFrontStorageLength = Number(params.cB_addStorage_front);
    prevBackStorageLength = Number(params.p_u_t);
    
    if (action.option == "frameout") {
        if (currentLength!= undefined){
            const_var.breezewayLength = currentLength;
            size = currentLength+'x'+Number(params.p_h);
            if ( (currentLength < prevFrameLength)) {
                params.cB_addStorage_front = params.p_d-params.p_u_t-currentLength;
                rightFrameout.entry_position.z = leftFrameout.entry_position.z = -(params.p_d/2) + params.p_u_t + currentLength/2;
            } 
            
            if ( currentLength > prevFrameLength && (params.p_d-currentLength-params.p_u_t) >= distanceOncenter ) {
                params.cB_addStorage_front = params.p_d-currentLength-params.p_u_t;
                rightFrameout.entry_position.z = leftFrameout.entry_position.z = -(params.p_d/2) + params.p_u_t + currentLength/2;
            } else if (currentLength > prevFrameLength && (params.p_d-currentLength-params.p_u_t) <= distanceOncenter ) {
                params.cB_addStorage_front = distanceOncenter;
                params.p_u_t =  params.p_d-params.cB_addStorage_front-currentLength;
                rightFrameout.entry_position.z = leftFrameout.entry_position.z = params.p_d/2-params.cB_addStorage_front-currentLength/2;
            }


            cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position, undefined,undefined,undefined,'isBreezewayFrame' );
            cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position, undefined,undefined,undefined,'isBreezewayFrame' );
        }
    }

    if ( action.option == "buildingHeight" ){
        if (height != undefined){
            size = const_var.breezewayLength+'x'+height;
            cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position, undefined,undefined,undefined,'isBreezewayFrame' );
            cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position, undefined,undefined,undefined,'isBreezewayFrame' );
        }
    }

    if ( action.option == "buildingWidth" ){ 
        leftFrameout.entry_position.x = -(params.p_w / 2) - posOffset;
        rightFrameout.entry_position.x = (params.p_w / 2) + posOffset;
        rightFrameout.entry_position.z = leftFrameout.entry_position.z = -( params.p_d / 2) + params.p_u_t + const_var.breezewayLength / 2;

        size =  const_var.breezewayLength+'x'+Number(params.p_h);
        cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position, undefined, undefined,undefined,'isBreezewayFrame' );
        cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position, undefined, undefined,undefined,'isBreezewayFrame' );
    }

    if ( action.option == "buildingLength" ){
        if (length !== undefined) {
            if ( distanceOncenter == 5 ) {
                const_var.breezewayLength = 10;
                if ( length % 10 == 0 ){
                    params.cB_addStorage_front =  (length - const_var.breezewayLength) / 2;
                    params.p_u_t = (length - const_var.breezewayLength) / 2;
                } else {
                    params.cB_addStorage_front =  (length - const_var.breezewayLength) / 2 + 2.5;
                    params.p_u_t = (length - const_var.breezewayLength) / 2 - 2.5;
                }
            }

            if ( distanceOncenter == 4 ) {
                const_var.breezewayLength = 8;
                if ( length % 4 == 0 ){
                    if (Object.values(const_var.breezewayFrontStorageOptions).includes((length - const_var.breezewayLength) / 2)){
                        params.cB_addStorage_front =  (length - const_var.breezewayLength) / 2 + 4;
                        params.p_u_t = (length - const_var.breezewayLength) / 2 - 4;
                    } else {
                        params.cB_addStorage_front =  (length - const_var.breezewayLength) / 2 + 2;
                        params.p_u_t = (length - const_var.breezewayLength) / 2 - 2;
                    }
               
                }
            }
        }
        size = const_var.breezewayLength+'x'+height
        leftFrameout.entry_position.z = rightFrameout.entry_position.z = -( params.p_d / 2) + params.p_u_t + const_var.breezewayLength / 2;
        if (popularSize === 'popularSize'){
            leftFrameout.entry_position.x = -params.p_w / 2 - posOffset;
            rightFrameout.entry_position.x = params.p_w / 2 + posOffset; 
        }


        cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position,undefined, undefined,undefined,'isBreezewayFrame' );
        cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position,undefined, undefined,undefined,'isBreezewayFrame' );
    }

    if ( action.option == "pickThisBuilding" ) {
        const_var.breezewayLength = params.p_d - params.cB_addStorage_front - params.p_u_t;
        size =  const_var.breezewayLength+'x'+Number(params.p_h);
        leftFrameout.entry_position.z = rightFrameout.entry_position.z = -( params.p_d / 2) + params.p_u_t + const_var.breezewayLength / 2;
        
        cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position,undefined, undefined,undefined,'isBreezewayFrame' );
        cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position,undefined, undefined,undefined,'isBreezewayFrame' );
    }

    if ( action.option == "frontStorageLength" ) {
        if ( currentLength < prevFrontStorageLength  && params.p_d-currentLength-params.p_u_t <= maxBreezewayLength) {
           params.cB_addStorage_front = currentLength;
           const_var.breezewayLength= params.p_d-params.cB_addStorage_front-params.p_u_t;
           size =  const_var.breezewayLength+'x'+Number(params.p_h);
        } else if ( currentLength < prevFrontStorageLength  && params.p_d-currentLength-params.p_u_t > maxBreezewayLength) {
            params.cB_addStorage_front = currentLength;
            const_var.breezewayLength = maxBreezewayLength;
            params.p_u_t =params.p_d-currentLength-const_var.breezewayLength;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        }
    
        if ( currentLength > prevFrontStorageLength  && params.p_d-currentLength-params.p_u_t >= distanceOncenter ){
            params.cB_addStorage_front = currentLength;
            const_var.breezewayLength = params.p_d-params.p_u_t-currentLength;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        }else if (currentLength > prevFrontStorageLength && (params.p_d-currentLength-params.p_u_t) <= distanceOncenter ) {
            params.cB_addStorage_front = currentLength;
            const_var.breezewayLength = distanceOncenter;
            params.p_u_t = params.p_d-const_var.breezewayLength-currentLength;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        }
        
        rightFrameout.entry_position.z = leftFrameout.entry_position.z = -( params.p_d / 2) + params.p_u_t + const_var.breezewayLength / 2;
        cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position, undefined,undefined,undefined,'isBreezewayFrame' );
        cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position, undefined,undefined,undefined,'isBreezewayFrame' );

    }

    if (action.option == "backStorageLength"){
        params.p_u_t = Number(action.value);

        if ( currentLength < prevBackStorageLength && params.p_d-currentLength-params.cB_addStorage_front <= maxBreezewayLength ) {
            params.p_u_t = currentLength;
            const_var.breezewayLength = params.p_d-params.cB_addStorage_front-params.p_u_t;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        } else if ( currentLength < prevBackStorageLength  && params.p_d-currentLength-params.cB_addStorage_front > maxBreezewayLength) {
            params.p_u_t = currentLength;
            const_var.breezewayLength = maxBreezewayLength;
            params.cB_addStorage_front =params.p_d - currentLength - const_var.breezewayLength;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        }
     
        if ( currentLength > prevBackStorageLength  && params.p_d-currentLength-params.cB_addStorage_front >= distanceOncenter ){
            params.p_u_t = currentLength;
            const_var.breezewayLength = params.p_d-params.cB_addStorage_front-currentLength;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        }else if (currentLength > prevBackStorageLength && (params.p_d-currentLength-params.cB_addStorage_front) <= distanceOncenter ) {
            params.p_u_t = currentLength;
            const_var.breezewayLength = distanceOncenter;
            params.cB_addStorage_front = params.p_d-const_var.breezewayLength-currentLength;
            size =  const_var.breezewayLength+'x'+Number(params.p_h);
        }
        rightFrameout.entry_position.z = leftFrameout.entry_position.z = -( params.p_d / 2) + params.p_u_t + const_var.breezewayLength / 2;
            
        cuComponent.RemoveDoorComponent(leftFrameout.uniqueId, leftFrameout.entry_type, 'standard_door', leftFrameout.component_wall_name, size, leftFrameout.parent_array_key, leftFrameout.child_array_key, leftFrameout.nested_array_key, leftFrameout.entry_rotation, leftFrameout.entry_position,undefined,undefined,undefined,'isBreezewayFrame' );
        cuComponent.RemoveDoorComponent(rightFrameout.uniqueId, rightFrameout.entry_type, 'standard_door', rightFrameout.component_wall_name, size, rightFrameout.parent_array_key, rightFrameout.child_array_key, rightFrameout.nested_array_key, rightFrameout.entry_rotation, rightFrameout.entry_position,undefined,undefined,undefined,'isBreezewayFrame' );

    }

    const_var.UpdatedPriceData.utility_price_changed = true;
    const_var.UpdatedPriceData.front_utility_price_changed = true;
    cuBuilding.cP();
    //cuBuilding.breezwayStoragevalues();
    cuBuilding.BuildingUpdate();

}

export const calculateLegsCount = (value,name)=>{
    
    let eqiDis = 0;
    let eqiDisfive = 0;
    let eqiDisCenter = 0;
    let eqiDisfiveCenter = 0;
    let exactLength = 0;

    let a_p_d_a = const_var.a_p_d_a

    let ExtraItemsFeaturesArray = []

    if(const_var.isLTBuilding){
        a_p_d_a = JSON.parse(JSON.stringify(const_var.holdPricingResponse));
        ExtraItemsFeaturesArray = const_var.lNTBuildingData.ExtraItemsFeaturesArray['centerBuilding']
    } else {
        ExtraItemsFeaturesArray = const_var.ExtraItemsFeaturesArray
    }
   
    if(name!=undefined)
    {
        exactLength = parseFloat(const_var.lengthData[name].length) + parseFloat(const_var.lengthData[name].porchLength);
        if(params.fourth_center_cost==true || const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4)
        {
            if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
            {
                if(const_var.isUpdate4ftLegLogic){
                    eqiDis = (params.oncenter_val_with_action!='')?((exactLength)/parseFloat(params.oncenter_val_with_action)):((exactLength)/parseFloat(const_var.DistanceArr[params.p_b_t][params.p_r_s]));
                    eqiDis = Math.ceil(eqiDis)
                }
                else{
                    eqiDis = (params.oncenter_val_with_action!='')?((exactLength)/parseInt(params.oncenter_val_with_action)).toFixed(0):((exactLength)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
                }

                eqiDisfive = (const_var.DistanceArr[params.p_b_t][params.p_r_s]==5)?((exactLength)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0):((exactLength)/parseInt(5)).toFixed(0);
                
                eqiDisfive = parseFloat(eqiDisfive) + 1;
                eqiDis = parseFloat(eqiDis) +1;
                if((params.add_left_front_lean_porch && name=="frontLean"))
                {
                    eqiDisfive = parseFloat(eqiDisfive) - 1;
                    eqiDis = parseFloat(eqiDis) -1;
                }
                if((params.add_left_back_lean_porch && name=="backLean") )
                {
                    eqiDisfive = parseFloat(eqiDisfive) - 1;
                    eqiDis = parseFloat(eqiDis) -1;
                }
                if((params.add_right_front_lean_porch && name=="frontLean"))
                {
                    eqiDisfive = parseFloat(eqiDisfive) - 1;
                    eqiDis = parseFloat(eqiDis) -1;
                }
                if((params.add_right_back_lean_porch && name=="backLean") )
                {
                    eqiDisfive = parseFloat(eqiDisfive) - 1;
                    eqiDis = parseFloat(eqiDis) -1;
                }
            }
        }
    }

    if(params.fourth_center_cost==true || (const_var.DistanceArr[params.p_b_t][params.p_r_s] != undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4))
    {
        if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
        {
            if(const_var.isUpdate4ftLegLogic){
                eqiDisCenter = (params.oncenter_val_with_action!='')?((params.p_d)/parseFloat(params.oncenter_val_with_action)):((params.p_d)/parseFloat(const_var.DistanceArr[params.p_b_t][params.p_r_s]));
                eqiDisCenter = Math.ceil(eqiDisCenter)
            }
            else{
                eqiDisCenter = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
            }
            eqiDisfiveCenter = (a_p_d_a.building_structure[0]?.distance_on_center==5)?((params.p_d)/parseInt(a_p_d_a.building_structure[0]?.distance_on_center)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
            eqiDisfiveCenter = parseFloat(eqiDisfiveCenter) + 1;
            eqiDisCenter = parseFloat(eqiDisCenter) +1;
        }
    } else {
        if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
        {
            if(const_var.isUpdate4ftLegLogic){
                eqiDisCenter = (params.oncenter_val_with_action!='')?((params.p_d)/parseFloat(params.oncenter_val_with_action)):((params.p_d)/parseFloat(const_var.DistanceArr[params.p_b_t][params.p_r_s]));
                eqiDisCenter = Math.ceil(eqiDisCenter)
            }
            else{
                eqiDisCenter = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0)
            }
            eqiDisfiveCenter = (a_p_d_a.building_structure[0]?.distance_on_center==5)?((params.p_d)/parseInt(a_p_d_a.building_structure[0]?.distance_on_center)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
            eqiDisfiveCenter = parseFloat(eqiDisfiveCenter) + 1;
        }
    }
                                       
    //                             }
    //                         }
    //                     })
    //                     }
    //                     }


    //                                         if(quantityData.cost!=0 || quantityData.double_leg!=0 || quantityData.ladder_leg!=0)
    //                                         {
    //                                             let bowsPrice = 0;
    //                                             if (name=="frontLean") bowsPrice = params.add_front_lean ? (params.leanF_p_e_l && const_var.leanFLegstype.includes("double") && quantityData.double_leg != 0 )?parseFloat(quantityData.double_leg):(params.leanF_p_e_l && const_var.leanFLegstype.includes("ladder") && quantityData.ladder_leg != 0 )?parseFloat(quantityData.ladder_leg):parseFloat(quantityData.cost) : 0;
    //                                             if (name=="leftLean") bowsPrice = params.add_left_lean ? (params.lean_p_e_l && const_var.leanLegstype.includes("double") && quantityData.double_leg != 0 )?parseFloat(quantityData.double_leg):(params.lean_p_e_l && const_var.leanLegstype.includes("ladder") && quantityData.ladder_leg != 0 )?parseFloat(quantityData.ladder_leg):parseFloat(quantityData.cost) : 0;
    //                                             if (name=="rightLean") bowsPrice = params.add_right_lean ? (params.leanR_p_e_l && const_var.leanRLegstype.includes("double") && quantityData.double_leg != 0 )?parseFloat(quantityData.double_leg):(params.leanR_p_e_l && const_var.leanRLegstype.includes("ladder") && quantityData.ladder_leg != 0 )?parseFloat(quantityData.ladder_leg):parseFloat(quantityData.cost) : 0;
    //                                             if (name=="backLean") bowsPrice = params.add_back_lean ? (params.leanB_p_e_l && const_var.leanBLegstype.includes("double") && quantityData.double_leg != 0 )?parseFloat(quantityData.double_leg):(params.leanB_p_e_l && const_var.leanBLegstype.includes("ladder") && quantityData.ladder_leg != 0 )?parseFloat(quantityData.ladder_leg):parseFloat(quantityData.cost) : 0;
    //                                             let exactNum = Math.abs(NumberOfLengsWith5ft - eqiDis);
                                                
    //                                             if(params.isDefaultfourFeet == true) {
    //                                                 ExtraItemsFeaturesArray[quantityval].cost = 0;
    //                                             } else {
    //                                                 ExtraItemsFeaturesArray[quantityval].cost = parseFloat(ExtraItemsFeaturesArray[quantityval].cost) + parseFloat(bowsPrice * exactNum)
    //                                             }
                                                
    //                                         }
    //                                     }
    //                                 })
    //                             }
    //                         })
    //                     }
                    
                    
                    
    //             }
    // }

    const l = ['right', 'left', 'back', 'front'].find(lean => `${lean}Lean` === name)

    if(l && params[`add_${l}_lean`] === true) {
        
        const extraBowsDisabledIndex = const_var.ExtraItemsFeaturesQuantityArray.findIndex(d => d?.name == 'bows')
                        
        if(const_var.isLTBuilding && extraBowsDisabledIndex > -1) {
            const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray[l][extraBowsDisabledIndex] = const_var.ExtraItemsFeaturesQuantityArray[extraBowsDisabledIndex];
        }
    }
}

export const commonFunctionForExtraBows = ()=>{
    let eqiDis = 0;
    let eqiDisfive = 0;
    const ExtraItemsFeaturesArray = const_var.isLTBuilding ? const_var.lNTBuildingData.ExtraItemsFeaturesArray.centerBuilding : const_var.ExtraItemsFeaturesArray;
    if(params.fourth_center_cost==true || (const_var.DistanceArr[params.p_b_t][params.p_r_s] != undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s] == 4))
    {
        if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
        {
            if(const_var.isUpdate4ftLegLogic){
                eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseFloat(params.oncenter_val_with_action)):((params.p_d)/parseFloat(const_var.DistanceArr[params.p_b_t][params.p_r_s]));
                eqiDis = Math.ceil(eqiDis)
            }
            else{
                eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
            }
            eqiDisfive = (const_var.a_p_d_a.building_structure[0]?.distance_on_center==5)?((params.p_d)/parseInt(const_var.a_p_d_a.building_structure[0]?.distance_on_center)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
            eqiDisfive = parseFloat(eqiDisfive) + 1;
            eqiDis = parseFloat(eqiDis) +1;
        }
    } else {
        if(const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined)
        {
            if(const_var.isUpdate4ftLegLogic){
                eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseFloat(params.oncenter_val_with_action)):((params.p_d)/parseFloat(const_var.DistanceArr[params.p_b_t][params.p_r_s]))
                eqiDis = Math.ceil(eqiDis)
            }
            else{
                eqiDis = (params.oncenter_val_with_action!='')?((params.p_d)/parseInt(params.oncenter_val_with_action)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0)
            }
            eqiDisfive = (const_var.a_p_d_a.building_structure[0]?.distance_on_center==5)?((params.p_d)/parseInt(const_var.a_p_d_a.building_structure[0]?.distance_on_center)).toFixed(0):((params.p_d)/parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
            eqiDisfive = parseFloat(eqiDisfive) + 1;
        }
    }
    if(const_var.ExtraItemsFeaturesQuantityArray.length>0 && params.isDefaultfourFeet!=true)
    {
        let FilterIndex = const_var.ExtraItemsFeaturesQuantityArray.findIndex(data=> data && data.name=="bows" && data.is_disabled!=undefined);
         if (FilterIndex >= 0){
            if(const_var.c_f_aCer[params.p_e_i]!=undefined && const_var.c_f_aCer[params.p_e_i].distance_on_center==5 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=4)
            {
                let quantityval = ExtraItemsFeaturesArray.findIndex(data => data && data.name=="fourth_center_cost");
                if(quantityval>=0)
                {
                    if(const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].cost==0)
                    {
                        if(ExtraItemsFeaturesArray[quantityval].is_checked)
                        {
                            ExtraItemsFeaturesArray[quantityval].is_checked = false;
                            params.fourth_center_cost = false;
                        }
                        const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].cost = 0;
                    }
                }
            }
            if(const_var.c_f_aCer[params.p_e_i]!=undefined && const_var.c_f_aCer[params.p_e_i].distance_on_center==5 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=4)
            {
                let quantityval = ExtraItemsFeaturesArray.findIndex(data => data && data.name=="fourth_center_cost");
                if(quantityval>=0)
                {
                    if(const_var.ExtraItemsFeaturesQuantityArray[FilterIndex].is_checked==false && ExtraItemsFeaturesArray[quantityval].cost!=0)
                    {
                        ExtraItemsFeaturesArray[quantityval].cost = 0;
                    }
                }
            }
        }
    }
    
}
export const handleCommonAttribute = (state, action) => {
	let UpdateVal = "";
	if (action.key == "Tax") {
		state.params.tax_exempt = !state.params.tax_exempt;
		UpdateVal = state.params.tax_exempt;
		const_var.tax = { percentage: 0, type: "%", name: "", amount: 0 };
		state.params.tax_zipcode = action.setZipCode != "" ? action.setZipCode : "";
		const_var.MoreTaxinputs = [];
		cuBuilding.cP();
	}
	return {
		...state,
		newColor: action.value + action.key + UpdateVal
	};
};
export const handleShowMeasure = (state, action) => {
	if (action.key != undefined && action.key == "save") {
		state.const_var.callMesure = false;
	} else {
		state.const_var.callMesure = !state.const_var.callMesure;
		const_var.crmSetting.is_show_wall_lable = const_var.callMesure;
	}
	return {
		...state,
		newColor: state.const_var.callMesure
	};
};
export const handleBookDemo = (state, action) => {
	if (const_var.crmSetting.main_domain_url == "Walkerbuildings.com") {
		if (action.value == true) {
			document.querySelector(".walk-checkout-modal").scrollTo({
				top: 0,
				behavior: "auto"
			});
		}
	}
	state.const_var.isOpenMeeting = action.value;
	return {
		...state,
		newColor: action.value
	};
};
